<template>
  <header class="header">
    <div class="left-section">
      <button @click="$emit('toggle-menu')" class="hamburger-menu" aria-label="Toggle menu">
        ☰
      </button>
      <nav class="lang-switcher" aria-label="Language">
        <template v-for="(lang, idx) in languages" :key="lang">
          <span v-if="idx > 0" class="lang-sep" aria-hidden="true">|</span>
          <button
            type="button"
            class="lang-btn"
            :class="{ active: currentLocale === lang }"
            :aria-pressed="currentLocale === lang"
            @click="changeLocale(lang)"
          >
            {{ lang.toUpperCase() }}
          </button>
        </template>
      </nav>
    </div>
    <div class="right-section">
      <div class="brand">
        <span class="brand-title">Swiss Eating Quiz</span>
        <span class="brand-version">{{ version }}</span>
      </div>
    </div>
  </header>
</template>

<script>
import i18n, { setLocale, SUPPORTED_LOCALES } from '@/i18n';

export default {
  name: 'AppHeader',
  emits: ['toggle-menu'],
  data() {
    return {
      version: 'Beta, 11.09.2026',
      languages: SUPPORTED_LOCALES,
    };
  },
  computed: {
    currentLocale() {
      return i18n.global.locale.value;
    },
  },
  methods: {
    changeLocale(loc) {
      setLocale(loc);
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f9fa;
  color: #333;
  padding: 10px 20px;
  height: 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.left-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.hamburger-menu {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.brand {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.brand-title {
  font-size: 18px;
  font-weight: 600;
  color: #42b983;
  letter-spacing: 0.2px;
}

.brand-version {
  font-size: 10px;
  color: #999;
  font-weight: 400;
  letter-spacing: 0.4px;
}

.right-section {
  display: flex;
  align-items: center;
}

.lang-switcher {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lang-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #999;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.15s ease;
  border-bottom: 2px solid transparent;
}

.lang-btn:hover {
  color: #2c3e50;
}

.lang-btn.active {
  color: #42b983;
  border-bottom-color: #42b983;
}

.lang-btn:focus-visible {
  outline: 2px solid #42b983;
  outline-offset: 2px;
  border-radius: 2px;
}

.lang-sep {
  color: #ddd;
  font-weight: 300;
  user-select: none;
}

@media (max-width: 600px) {
  .brand-version {
    display: none;
  }
  .brand-title {
    font-size: 16px;
  }
}
</style>
